module.exports = __webpack_public_path__ + "static/img/detail_village_01.cc90022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/supermarket-mobile-app/detail_village_01.jpg
// module id = 278
// module chunks = 2